import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useMatomo } from '@datapunt/matomo-tracker-react';
import * as allPages from '../../pages';
import { isActive as isMatomoActive} from '../../modules/matomo';
import { useLocation } from 'react-router';
import { setCanonicalLink } from '../../modules/canonical-link';

const DynamicPageRenderer = (props) => {
  const { trackPageView } = useMatomo();
  const { pageName } = props;
  const PageComp = allPages[pageName];
	const {pathname} = useLocation();

	useEffect(() => {
		setCanonicalLink();
	}, [pathname]);

  useEffect(() => {
    if (isMatomoActive()) {
      trackPageView();
    }
  }, [trackPageView, pageName]);

  if (!PageComp) {
    console.error("Page Doesn't exists", props);
    // TODO: redirect to 404
    return 'Page Not Found 404';
  }
  return <PageComp {...props} />;
};

DynamicPageRenderer.propTypes = {
  pageName: PropTypes.string.isRequired // Must get a page name
};

export default DynamicPageRenderer;